import {customAxiosBE} from "../config";
import axios from "axios";
import {parsePaginationParams} from "../../utils/other";

export async function getStationByIdApi(id) {
    return customAxiosBE.get(`/station/${id}`)
}

export async function getAllStationsApi(operatorUid) {
    let query = ""
    if (operatorUid) {
        query = "?operatorUid=" + operatorUid
    }
    return customAxiosBE.get(`/station${query}`)
}

export async function getAllStationsInUseApi(operatorUid) {
    let query = ""
    if (operatorUid) {
        query = "?operatorUid=" + operatorUid
    }
    return customAxiosBE.get(`/stationsInUse${query}`)
}

export async function getAllDefaultDepStationsApi(depStationsIds) {
    if (depStationsIds?.length > 0) {
        return customAxiosBE.post(`/station/defaultDepStations`, depStationsIds)
    }
}

export async function getAllArrivalStationsByDepStationId(id, userUID) {
    if (userUID) {
        return customAxiosBE.get(`/station/arrival/${id}?operatorUid=${userUID}`)
    }
    return customAxiosBE.get(`/station/arrival/${id}`)
}

export async function getAllStationsByLineId(id) {
    return customAxiosBE.get(`/station/line/${id}`)
}

export async function getAllStationsLinkedByLineId(lineId, tripId = null, linkId = null) {
    const params = new URLSearchParams();
    if (tripId) params.append('tripId', tripId);
    if (linkId) params.append('linkId', linkId);

    return customAxiosBE.get(`/station/line/${lineId}/stations?${params.toString()}`);
}



export function insertStationAPI(data) {
    return customAxiosBE.post(`/station`, data)
}

export function updateStationAPI(data) {
    return customAxiosBE.put(`/station`, data)
}

export function deleteStationAPI(id) {
    return customAxiosBE.delete(`/station/${id}`)
}

export function stationUsageInfoAPI(id) {
    return customAxiosBE.get(`/station/usage-info/${id}`)
}

export function getAllStationsByOperatorAPI(operatorId){
    return customAxiosBE.get(`/station/by-operator/${operatorId}`)
}

export const searchStationAPI = async (data, cancelToken) => {
    let response
    const {name, includeCityStops, onlyCityStops} = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`/station/search?${parsedParams}`, {
                name: name,
                onlyOfficial: true,
                includeCityStops: !!includeCityStops,
                onlyCityStops: !!onlyCityStops
            },
            {
                cancelToken
            })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            console.error('usao u err!!!')
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

